<template>
    <v-dialog
        v-model="innerValue"
        v-bind="$attrs"
        max-width="30em"
    >
        <v-card>
            <v-img
                src="/images/refer-and-earn.jpg"
                height="286"
            />

            <v-card-title>Refer and Earn</v-card-title>

            <v-card-text>
                <p>
                    Hey there! We've got some exciting news to share - Kaoshi Network app now has a referral feature!
                    This means that when you invite your friends and family to join Kaoshi, you'll get
                    a sweet 2.5% referral fee for each successful referral. All you have to do is share your
                    unique referral link or code with your contacts, and when they sign up and complete a transaction,
                    you'll earn some extra cash. Plus, you'll be helping your loved ones discover a convenient
                    and reliable P2P currency marketplace. So what are you waiting for?
                    Start referring today and watch your earnings grow!
                </p>

                <p>
                    <router-link :to="{ name: 'referral-terms' }">
                        Terms . Privacy
                    </router-link>
                </p>
            </v-card-text>

            <v-card-actions>
                <v-btn
                    :loading="loading"
                    color="primary white--text"
                    block
                    @click="join"
                >
                    Join and Earn
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        value: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: () => ({
        loading: false,
    }),
    computed: {
        innerValue: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    methods: {
        async join() {
            try {
                this.loading = true;
                await Vue.backendApi()
                    .user(this.$store.state.user.id)
                    .storeReferralSettings({
                        referral_program_enabled: true,
                    });

                await Vue.backendApi()
                    .user(this.$store.state.user.id)
                    .getUserSettings()
                    .then(({ data }) => {
                        this.$store.commit('loadUserSettings', data);
                    });
                this.innerValue = false;
            } catch (error) {
                this.$swal({
                    type: 'error',
                    title: 'Error saving setting',
                    text: error,
                });
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>
